module.exports = __webpack_public_path__ + "img/vip.65a30fc8.svg";